import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getMe } from "../services/session";

const PrivateRoute = ({ children }) => {
    const [status, setStatus] = useState("loading"); // loading | ok | no

    useEffect(() => {
        let isMounted = true;
        (async () => {
            const me = await getMe();
            if (!isMounted) return;
            if (me && me.user_type === "admin") {
                setStatus("ok");
            } else {
                setStatus("no");
            }
        })();
        return () => {
            isMounted = false;
        };
    }, []);

    if (status === "loading") return null;
    if (status === "no") return <Navigate to="/" replace />;
    return children;
};

export default PrivateRoute;